import React, { Component } from 'react'
import { withStyles, Drawer, Typography, Divider, TextField, Button, AppBar, Toolbar, IconButton, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Grid } from '@material-ui/core';
import FileUpload from '../../AddNew/FileUpload';

const drawerWidth = 500;

const styles = theme => ({
    root: {
        width: drawerWidth,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '100%'
    },
    textStyle: {
        fontWeight: 400
    },
    paddingForm: {
        padding: '20px'
    },
    formControl: {
        margin: theme.spacing.unit
    }
})

const type = [
    {
        label: 'Gallery',
        value: 'GALLERY'
    },
    {
        label: 'Syllabus',
        value: 'SYLL'
    },
    {
        label: 'Academic Calendar',
        value: 'AC'
    },
    {
        label: 'Time Table',
        value: 'TT'
    },
    {
        label: 'List of Holidays',
        value: 'LOH'
    },
    {
        label: 'Laboratory',
        value: 'LAB'
    },
    {
        label: 'Projects',
        value: 'PR'
    },
    {
        label: 'Best Practices',
        value: 'BEST_PRACTICES'
    },
    {
        label: 'Course Materials',
        value: 'COM'
    }
]

const sub_type = [
    {
        label: 'COs',
        value: 'CO'
    },
    {
        label: 'CO-PO table',
        value: 'COPO'
    },
    {
        label: 'Course Plan',
        value: 'COPL'
    },
    {
        label: 'Syllabus',
        value: 'COSYL'
    },
    {
        label: 'Course Materials',
        value: 'COSYM'
    },

]

const semesters = [
    {
        label: '1st Sem - Group B',
        value: '1B'
    },
    {
        label: '2nd Sem - Group B',
        value: '2B'
    },
    {
        label: '3rd Sem',
        value: '3'
    },
    {
        label: '4th Sem',
        value: '4'
    },
    {
        label: '5th Sem',
        value: '5'
    },
    {
        label: '6th Sem',
        value: '6'
    },
    {
        label: '7th Sem',
        value: '7'
    },
    {
        label: '8th Sem',
        value: '8'
    }
]


class FileAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            batch: '',
            name: '',
            roll_no: '',
            employer: '',
            file: [],
            id: ''
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);

    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    componentDidMount() {
        if (this.props.edit) {
            this.setState({
                ...this.props.edit_data
            })
        } else {
            this.setState({
                batch: '',
                name: '',
                roll_no: '',
                employer: '',
                file: [],
                id: ''
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.edit !== this.props.edit) {
            if (this.props.edit) {
                this.setState({
                    ...this.props.edit_data
                })
            } else {
                this.setState({
                    batch: '',
                    name: '',
                    roll_no: '',
                    employer: '',
                    file: [],
                    id: ''
                })
            }
        }
    }


    onSubmit(e) {
        e.preventDefault();

        const data = this.state;

        if (this.props.edit) {
            this.props.esetData(data);

        } else {
            this.props.setData(data);
            this.setState({
                batch: '',
                name: '',
                roll_no: '',
                employer: '',
                file: [],
                id: ''

            })
        }

    }

    onDeleteClick(id) {
        this.props.onDeleteClick(id);
    }

    onSetFile = (data) => {
        //console.log(data)
        this.setState({
            file: data
        })
    }

    render() {
        let { classes } = this.props;
        return (
            <div>
                <Drawer
                    className={classes.root}
                    anchor="right"
                    open={this.props.show}
                    onClose={this.props.handleClose}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >

                    <AppBar position="static" color={this.props.edit ? "secondary" : "primary"} >
                        <Toolbar>
                            <Typography variant="h6" color="inherit" >
                                {this.props.edit ? "Edit DATA" : "Add New"}
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <div className={classes.paddingForm}>

                        <form onSubmit={this.onSubmit}>


                            <Grid container spacing={24}>










                                <Grid item xs={12} sm={12} md={12} lg={12}>

                                    <TextField
                                        variant="outlined"
                                        label="Batch"
                                        className={classes.textField}
                                        type="text"
                                        name="batch"
                                        autoComplete="current-password"
                                        margin="normal"
                                        required
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.textStyle
                                            }
                                        }}
                                        value={this.state.batch}
                                        onChange={this.onChange}
                                    />


                                    <TextField
                                        variant="outlined"
                                        label="Name"
                                        className={classes.textField}
                                        type="text"
                                        name="name"
                                        autoComplete="current-password"
                                        margin="normal"
                                        required
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.textStyle
                                            }
                                        }}
                                        value={this.state.name}
                                        onChange={this.onChange}
                                    />

                                    <TextField
                                        variant="outlined"
                                        label="Name"
                                        className={classes.textField}
                                        type="text"
                                        name="roll_no"
                                        autoComplete="current-password"
                                        margin="normal"
                                        required
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.textStyle
                                            }
                                        }}
                                        value={this.state.roll_no}
                                        onChange={this.onChange}
                                    />


                                    <TextField
                                        variant="outlined"
                                        label="Name"
                                        className={classes.textField}
                                        type="text"
                                        name="employer"
                                        autoComplete="current-password"
                                        margin="normal"
                                        required
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.textStyle
                                            }
                                        }}
                                        value={this.state.employer}
                                        onChange={this.onChange}
                                    />






                                </Grid>


                               

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <FileUpload
                                        dp={this.state.file}
                                        apikey={this.props.apikey}
                                        type={`PLACEMENTS`}
                                        setDp={this.onSetFile.bind(this)}
                                    />



                                </Grid>



                            </Grid>

                            <br />
                            <br />





                            <div>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    color={this.props.edit ? "secondary" : "primary"}
                                    className={classes.button}>
                                    {this.props.edit ? "Update" : "Submit"}
                                </Button>

                                {this.props.edit ?
                                    <span>&nbsp;
                                        <Button
                                            type="button"
                                            variant="contained"
                                            color="secondary"
                                            className={classes.button}
                                            onClick={this.onDeleteClick.bind(this, this.props.edit_data.id)}
                                        >
                                            Delete
                                        </Button>
                                    </span>

                                    : null}
                            </div>
                        </form>

                    </div>



                </Drawer>
            </div>
        )
    }
}

export default withStyles(styles)(FileAdd)


// WEBPACK FOOTER //
// ./src/Components/Master/StudentPublication/FileAdd.js